// File: src/pages/Apps.js
import React, { useMemo, useState } from "react";
import "./Yukle.css";

function isValidHttpUrl(url) {
  try {
    const parsedUrl = new URL(url);

    return (
      parsedUrl.protocol === "http:" ||
      parsedUrl.protocol === "https:"
    );
  } catch {
    return false;
  }
}

const APPS = [
  {
    id: "sifarisqrupu2",
    name: "Sifariş Qrupu 2",
    icon: "/apps/sifarisqrupu.png",
    androidLink: "https://pixeldrain.com/u/G6dicfpR",
    iosLink:
      "https://apps.apple.com/app/sifari%C5%9F-qrupu-2/id6748552181",
  },
];

export default function Yukle() {
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(null);

  const filteredApps = useMemo(() => {
    const normalizedQuery = query
      .trim()
      .toLocaleLowerCase("az-AZ");

    if (!normalizedQuery) {
      return APPS;
    }

    return APPS.filter((app) =>
      app.name
        .toLocaleLowerCase("az-AZ")
        .includes(normalizedQuery)
    );
  }, [query]);

  const hasAndroidLink = (app) =>
    isValidHttpUrl(app?.androidLink);

  const hasIosLink = (app) =>
    isValidHttpUrl(app?.iosLink);

  const closeModal = () => {
    setSelected(null);
  };

  return (
    <div className="apps-page">
      <div className="apps-header">
        <div className="apps-title-row">
          <h1 className="apps-title">
            Bütün Proqramlar
          </h1>
        </div>

        <div className="apps-search">
          <input
            value={query}
            onChange={(event) =>
              setQuery(event.target.value)
            }
            placeholder="Proqram axtar..."
            aria-label="Proqram axtarışı"
          />
        </div>
      </div>

      <div className="apps-grid">
        {filteredApps.map((app) => (
          <button
            key={app.id}
            className="app-card"
            type="button"
            onClick={() => setSelected(app)}
          >
            <div className="app-icon-wrap">
              <img
                src={app.icon}
                alt={app.name}
                className="app-icon"
                onError={(event) => {
                  event.currentTarget.style.display =
                    "none";
                }}
              />

              <div
                className="app-icon-fallback"
                aria-hidden="true"
              >
                {app.name
                  ?.slice(0, 1)
                  ?.toUpperCase()}
              </div>
            </div>

            <div
              className="app-name"
              title={app.name}
            >
              {app.name}
            </div>
          </button>
        ))}

        {filteredApps.length === 0 && (
          <div className="app-empty">
            Axtarışa uyğun proqram tapılmadı.
          </div>
        )}
      </div>

      {selected && (
        <div
          className="app-modal-backdrop"
          onClick={closeModal}
          role="presentation"
        >
          <div
            className="app-modal"
            onClick={(event) =>
              event.stopPropagation()
            }
            role="dialog"
            aria-modal="true"
            aria-label={selected.name}
          >
            <div className="app-modal-top">
              <div className="app-modal-icon">
                <img
                  src={selected.icon}
                  alt={selected.name}
                  onError={(event) => {
                    event.currentTarget.style.display =
                      "none";
                  }}
                />

                <div
                  className="app-modal-fallback"
                  aria-hidden="true"
                >
                  {selected.name
                    ?.slice(0, 1)
                    ?.toUpperCase()}
                </div>
              </div>

              <div className="app-modal-info">
                <div className="app-modal-name">
                  {selected.name}
                </div>
              </div>

              <button
                className="app-modal-close"
                type="button"
                onClick={closeModal}
                aria-label="Bağla"
              >
                ✕
              </button>
            </div>

            <div className="app-modal-actions">
              {hasAndroidLink(selected) && (
                <a
                  className="app-btn android"
                  href={selected.androidLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  Android üçün
                </a>
              )}

              {hasIosLink(selected) && (
                <a
                  className="app-btn ios"
                  href={selected.iosLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  iPhone üçün
                </a>
              )}

              {!hasAndroidLink(selected) &&
                !hasIosLink(selected) && (
                  <div className="app-empty">
                    Bu tətbiq üçün hələ link
                    əlavə edilməyib.
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}